export default __webpack_public_path__ + "static/media/36_desktop.60935f23.jpg";